import React from 'react';
import './styles.css';
import { ENTERPRISE_AUTOMATED } from 'utils/constants';
import { gotoUrl } from 'utils/helpers';
import FormattedMessage from 'components/FormattedMessage/index';

const AddSimSummary = ({
  simCounts,
  isSimTypeEsim
}) => {
  const {newSimCount,transferSimCount} = simCounts;
  const onEdit = () =>{
    gotoUrl("/enterprise/automated-onboarding?edit=true")
  }
  return (
    <div className="your-plan-card">
      {/* Header */}
      <div className="your-plan-header">
        <h2 className="your-plan-title">Your plan</h2>
        <button type="button" className="edit-btn" onClick={onEdit}>
          Edit
        </button>
      </div>

      {/* SIM Type */}
      <div className="plan-section">
        <span className="section-label">SIM type</span>
        <div className="section-value">{isSimTypeEsim ? ENTERPRISE_AUTOMATED.ESIM : ENTERPRISE_AUTOMATED.PSIM}</div>
      </div>

      <hr className="plan-divider" />

      {/* New Number */}
      {newSimCount > 0 && (
        <div className="plan-section">
          <span className="section-label">New number</span>
          <div className="section-value">
            {newSimCount} {newSimCount === 1 ? 'line' : 'lines'}
          </div>

          <div className="info-banner">
            <svg
              className="info-icon"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#64748b"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
            <span className="info-text">
              <FormattedMessage id="ent_getting_new_number_summary_content" defaultMessage="" />
            </span>
          </div>
        </div>
      )}

      {/* Transfer Number */}
      {transferSimCount > 0 && (
        <div className="plan-section">
          <span className="section-label">Transfer number</span>
          <div className="section-value">
            {transferSimCount} {transferSimCount === 1 ? 'line' : 'lines'}
          </div>

          <div className="info-banner align-top">
            <svg
              className="info-icon"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#64748b"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
            <FormattedMessage html id="ent_getting_transfer_number_summary_content" defaultMessage="" />
          </div>
        </div>
      )}
    </div>
  );
};

export default AddSimSummary;